import { useMutation } from '@tanstack/react-query';
import { AxiosProxy } from '../../api/axiosProxy/axiosProxy';
import { AppSettingNames } from '@manifest-cyber/types/dist/appSettings';

interface Params {
  name: string;
  value: boolean;
}

export const useToggleAppSetting = () => {
  return useMutation({
    mutationFn: ({ name, value }: Params) => {
      const appSettingName: string =
        AppSettingNames[name as keyof typeof AppSettingNames];
      return AxiosProxy.put({
        url: `/admin/app-settings/${appSettingName}`,
        withCredentials: true,
        body: {
          value,
        },
      });
    },
  });
};
